<div
  *ngIf="isLoading$ | async"
  class="fixed inset-0 z-50 flex items-center justify-center
         bg-brand-surface/70 backdrop-blur-sm"
>
  <div
    role="status"
    aria-live="assertive"
    class="flex flex-col items-center gap-4
           px-8 py-6 rounded-2xl
           bg-brand-surface-card
           border border-brand-subtle
           shadow-xl"
  >
    <div class="loading-overlay__spinner"></div>

    <p class="text-brand-ink font-semibold">
      {{ 'COMMON.LOADING' | translate }}
    </p>
  </div>
</div>